module.exports = __webpack_public_path__ + "65971036fa749376dbe798ee07cf7375.fbx";